import { isWithinRange, startOfHour, subMinutes } from 'date-fns';

const cloneDate = (date, hour, mins = 0) => {
  const newDate = startOfHour(new Date(date));
  return newDate.setHours(hour);
};

const checkRange = (date, st, fn) => {
  const start = cloneDate(date, st);
  const finish = cloneDate(date, fn);
  return isWithinRange(date, start, subMinutes(finish, 1));
};

const periodChecker = date => {
  if (checkRange(date, 0, 12)) return 'morning';
  if (checkRange(date, 12, 18)) return 'afternoon';
  return 'evening';
};

export default items => {
  const timeSections = items.reduce(
    (timePeriods, item) => {
      const key = periodChecker(item.start);
      timePeriods[key] = timePeriods[key].concat([item]);
      return timePeriods;
    },
    { morning: [], afternoon: [], evening: [] }
  );

  return timeSections;
};
